// Záměr otevření agendy z menu, který „překlene" round-trip přes Magic.
//
// Klik na položku menu pošle Magicu `desktop/click-menu-item`; Magic agendu otevře ve svém
// navigátoru a claim ji přepošle zpět Phoenixu jako `form/open`. Mezi tím si tu podržíme, JAK
// má Phoenix výslednou agendu zobrazit:
//   - `replace`  → nahradit komplet plochu (openRoot),
//   - `detached` → otevřít rovnou v samostatném (plovoucím) okně.
// Bez záměru (navigace zevnitř agendy) = běžný modal. Consume-once: vyzvedne se prvním `form/open`.

import { setPendingLegacyNavSource } from '@/shared/lib/legacyMagic';

export type MenuOpenMode = 'replace' | 'detached';

export interface PendingMenuOpen {
  readonly mode: MenuOpenMode;
  /** Titulek položky menu — pro hezčí název v historii (form/open nese jen GlobalName). */
  readonly title?: string;
}

let pending: PendingMenuOpen | null = null;

/** Zaznamená záměr před odesláním `desktop/click-menu-item`. */
export function setPendingMenuOpen(mode: MenuOpenMode, title?: string): void {
  pending = { mode, title };
  // Otevření z menu a navigace ze vrstvy jsou vzájemně výlučné záměry: zapomenutý zdroj (Magic
  // předchozí navigaci neprovedl) by jinak menu-klik zařadil do stacku dávno zavřeného okna.
  setPendingLegacyNavSource(null);
}

/** Vyzvedne a vymaže čekající záměr (consume-once). */
export function consumePendingMenuOpen(): PendingMenuOpen | null {
  const value = pending;
  pending = null;
  return value;
}
